import {
  getInstrumentMeta,
  usesDollarQuoteDisplay,
  type MarketInstrumentKey,
} from '@/lib/market-rates'
import UsdInlineIcon from '@/components/market/UsdInlineIcon'

type MarketInstrumentLabelProps = {
  instrumentKey: MarketInstrumentKey
  variant?: 'label' | 'title'
  size?: 'xs' | 'sm' | 'md'
  className?: string
}

const TEXT_SIZE = {
  xs: 'text-[10px] font-bold uppercase tracking-wide sm:text-[11px]',
  sm: 'text-xs font-semibold uppercase tracking-wide sm:text-sm',
  md: 'text-sm font-semibold uppercase tracking-wide',
} as const

const ICON_HEIGHT = {
  xs: 'h-[10px] w-[10px] sm:h-[11px] sm:w-[11px]',
  sm: 'h-[11px] w-[11px] sm:h-[12px] sm:w-[12px]',
  md: 'h-[12px] w-[12px] sm:h-[13px] sm:w-[13px]',
} as const

export default function MarketInstrumentLabel({
  instrumentKey,
  variant = 'label',
  size = 'sm',
  className = '',
}: MarketInstrumentLabelProps) {
  const meta = getInstrumentMeta(instrumentKey)
  const text = variant === 'title' ? meta.displayTitle : meta.label
  const showDollar = usesDollarQuoteDisplay(instrumentKey)
  const textClass =
    variant === 'title'
      ? 'text-[1.35rem] font-bold leading-tight normal-case text-gray-900 dark:text-gray-100 sm:text-2xl'
      : `${TEXT_SIZE[size]} text-gray-500 dark:text-gray-400`

  return (
    <span className={`inline-flex min-w-0 items-center ${className}`}>
      <span className={textClass}>{text}</span>
      {showDollar ? (
        <span className="inline-flex shrink-0" aria-label="USD" title="USD">
          <UsdInlineIcon
            className={`${variant === 'title' ? 'h-[14px] w-[14px] sm:h-[16px] sm:w-[16px]' : ICON_HEIGHT[size]} ml-0.5 text-emerald-600 dark:text-emerald-400`}
          />
        </span>
      ) : null}
    </span>
  )
}
